module.exports = __webpack_public_path__ + "static/media/HH4H-paintbrush.43481ade.svg";